export default __webpack_public_path__ + "src/download/arquivoGuiaImportacaoBeneficiarios.csv";